import React from 'react';
import {
  Box,
  Center,
  Heading,
  VStack,
  Icon,
  Text,
  Button
} from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';

export default function SessionExpiredPage() {

  return (
    <Box w="100vw" h="100vh" bg="gray.50">
      <Center h="100%">
        <VStack spacing={6}>
          <Icon as={WarningIcon} boxSize={20} color="orange.400" />
          <Heading as="h1" size="2xl" color="gray.700" textAlign="center">
            Session expired
          </Heading>
          <Text fontSize="lg" color="gray.500" textAlign="center">
            Your session has expired or there were anomalies detected.
            Please logout.
          </Text>
        </VStack>
      </Center>
    </Box>
  );
}
